<template>
  <div class="open_btn_container">
    <!-- 预约提醒+开通按钮+领取权益 -->
    <div class="open_btn_double" v-show="btnDisplay == 4">
      <div class="open_btn_left" @click="jumpToGetPage"></div>
      <div class="open_btn_right" @click="openMember">
        <div class="open_price">
          <div class="price_tag">¥</div>
          <div class="price_num">{{ userPrice }}</div>
        </div>
        <div class="save_container">
          <div class="save_tag">立省</div>
          <div class="save_num">¥{{ userPriceSavePrice }}</div>
        </div>
      </div>
    </div>
    <div class="open_btn_single" v-show="btnDisplay != 4">
      <!-- 预约(预约提醒) -->
      <div class="order_btn" @click="showPhoneNumber" v-show="btnDisplay == 0">
        <div class="open_price">
          <div class="price_tag">¥</div>
          <div class="price_num">{{ userPrice }}</div>
          <div class="original_price">¥{{ original_price }}</div>
        </div>
        <div class="save_container">
          <div class="save_tag">立省</div>
          <div class="save_num">¥{{ userPriceSavePrice }}</div>
        </div>
      </div>
      <!-- 已预约(11月7日 11:11限量开抢) -->
      <div class="has_ordered_btn" v-show="btnDisplay == 1"></div>
      <!-- 抢购按钮(限量抢购) -->
      <div class="single_open_btn" v-show="btnDisplay == 2" @click="openMember">
        <div class="open_price">
          <div class="price_tag">¥</div>
          <div class="price_num">{{ userPrice }}</div>
          <!-- <div class="original_price">¥{{ userPriceSavePrice }}</div> -->
          <div class="original_price">¥{{ original_price }}</div>
        </div>
        <div class="save_container">
          <div class="save_tag">立省</div>
          <div class="save_num">¥{{ userPriceSavePrice }}</div>
        </div>
      </div>
      <!-- 领取会员权益(领取会员权益) -->
      <div
        class="get_member_auth"
        v-show="btnDisplay == 3"
        @click="jumpToGetPage"
      ></div>

      <!-- 本设备已开通4次，不能继续购买 -->
      <div class="no_open_chance" v-show="btnDisplay == 5"></div>
      <!-- 开通阶段结束，用户未曾开通过 -->
      <div class="user_cant_open" v-show="btnDisplay == 6"></div>
    </div>

    <!-- 端外直付组件 -->
    <payaction
      ref="payaction"
      :visible.sync="visible"
      :req="res_payment"
      @res="res_pay"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import h5init from "@kkmh/h5init";

import { h5directpay } from "@/assets/js/common/hybrid/kkhybrid";
import { miniprogramNav } from "@/assets/fe_js/common/miniprogram/utils";
import { fix } from "../js/fix_ele";

// comp
import payaction from "@/components/web/pay/action"; // 直付组件
// api

const { log } = console;

export default {
  data() {
    return {
      visible: false,
      res_payment: {},
    };
  },
  props: ["from"],
  computed: {
    ...mapState([
      "is_login",
      "reservation_status",
      "activity_status",
      "can_assign_count",
      "topic_id",
      "comic_id",
      "open_price",
      "original_price",
      "is_jailbroken_phone",
      "is_jailbroken_phone_url",
      "third_activity",
      "origin",
      "comp_init",
      "activity_name",
      "activity_name_topic",
      "is_ipad",
      "member_remain_days",
      "open_btn_init",
      "call_apppay",
    ]),
    btnDisplay: function () {
      if (this.activity_status == 1 && this.reservation_status == 0) return 0; // 预约(预约提醒)
      if (this.activity_status == 1 && this.reservation_status == 1) return 1; // 已预约(11月7日 11:11限量开抢)
      if (
        this.activity_status == 2 &&
        this.can_assign_count == -1 &&
        this.open_price.id != 0
      ) {
        this.SET_OPEN_FROM_BAIDU(2);
        return 2; // 抢购按钮(限量抢购)
      }
      if (
        (this.activity_status == 3 && this.can_assign_count != -1) ||
        (this.activity_status == 2 &&
          this.can_assign_count != -1 &&
          this.open_price.id == 0)
      ) {
        this.SET_OPEN_FROM_BAIDU(3);
        return 3; // 领取会员权益(领取会员权益)
      }
      if (
        this.activity_status == 2 &&
        this.can_assign_count != -1 &&
        this.open_price.id != 0
      ) {
        this.SET_OPEN_FROM_BAIDU(4);
        return 4; // 领取权益和限量抢购按钮同时存在
      }
      if (
        this.activity_status == 2 &&
        this.can_assign_count == -1 &&
        this.open_price.id == 0
      ) {
        this.SET_OPEN_FROM_BAIDU(5);
        return 5; // 同一设备用其他账号购买过4次
      }

      if (this.activity_status == 3 && this.can_assign_count == -1) {
        this.SET_OPEN_FROM_BAIDU(6);
        return 6; // 活动开通结束，在领取阶段，但是用户未开通过
      }
      // this.SET_OPEN_FROM_BAIDU(5);
      // return 5;
    },
    userPrice: function () {
      let coupon_price =
        this.open_price.coupon != undefined ? this.open_price.coupon.amount : 0;
      return this.open_price.price - coupon_price / 100;
    },
    userPriceSavePrice: function () {
      return this.original_price - this.userPrice;
    },
  },
  watch: {
    comp_init: function () {
      if (this.comp_init && this.from == "platform") {
        this.initPayment();
      }
    },
    call_apppay: function () {
      if (this.call_apppay) {
        this.outAppPay();
      }
    },
  },
  components: {
    payaction,
  },
  created: function () {
    (() => {
      window.subscribeListenerOnViewBack = (res) => {
        console.log("返回当前H5,关闭支付loading");
        this.SET_SHOW_LOADING(false);
      };
    })();
  },
  mounted: function () {},
  methods: {
    ...mapMutations([
      "SET_SHOW_PHONE_NUMBER",
      "SET_REFRESH_DATA",
      "SET_REFRESH_MEMBERGOOD_LIST",
      "SET_SHOW_LOADING",
      "SET_OPEN_BTN_INIT",
      "SET_OPEN_FROM_BAIDU",
      "SET_CALL_APPPAY",
    ]),

    // 百度方进入h5开通阶段自动唤起支付
    fromBaiduCallPay() {
      log("启动判断百度1");
      if (this.activity_status != 2) {
        return;
      }
      if (this.btnDisplay == 3) {
        log("从百度进入开通次数达到4次，不可继续开通");
        return;
      }
      log("启动判断百度2", this.$kkmh.qs()["from"] == "baidu");

      this.$kkmh.qs()["from"] == "baidu" && this.handleSwanLoaded();
    },

    // 百度小程序sdk加载完成后再唤起支付
    handleSwanLoaded() {
      if (swan) {
        log("百度sdk已加载");
        // sdk已加载
        this.btnDisplay != 3 && this.outAppPay();
      } else {
        log("百度sdk未加载");
        setTimeout(() => {
          if (swan) {
            this.btnDisplay != 3 && this.outAppPay();
          } else {
            this.$showToast("网络加载失败，请重新进入页面");
          }
        }, 500);
      }
    },

    // 端外直付初始化
    initPayment() {
      if (this.$kkmh.ua().kkmh) {
        return;
      }

      this.setReqPayment();
    },

    // 重新获取设备信息
    refreshH5Init(mode) {
      (async () => {
        let res = await h5init({ login_mode: mode });
        window.__nativeInit = true;
      })();
    },
    // 设置端外直付参数
    setReqPayment() {
      let bind_phone = this.isMiniProgram()["baidumini"] ? 1 : 0;
      // NOTICE:支付之后的跳转链接不要加from=baidu，防止有剩余次数时连续调起开通
      // let redirect_url = location.href.split("&from=baidu").join("");
      let redirect_url = "";

      if (
        this.isMiniProgram()["wechatmini"] ||
        this.isMiniProgram()["qqmini"]
      ) {
        // 微信、qq小程序中
        redirect_url = location.href;
      } else if (this.isMiniProgram()["baidumini"]) {
        log("设置参数----进入百度");
        // 百度小程序中
        if (/miniback=baidu/.test(redirect_url)) {
          redirect_url = location.href.split("&from=baidu").join("");
          // let url_1=location.href.split("&session")[0];
          // let url_2=location.href.split("&session=")[1];
          // redirect_url = url_1.split("&from=baidu").join("")+'&session='+url_2;
        } else {
          redirect_url =
            location.href.split("&from=baidu").join("") + "&miniback=baidu";
          // let url_3=location.href.split("&session")[0];
          // let url_4=location.href.split("&session=")[1];
          // redirect_url =
          //   url_3.split("&from=baidu").join("")+ "&miniback=baidu"+'&session='+url_4;
          // redirect_url = location.href;
        }
      } else if (this.$kkmh.qs()["from"] == "baidu") {
        // h5-来自百度
        redirect_url =
          "https://smartprogram.baidu.com/developer/activity/unitedmember/index.html";
      } else {
        // h5-其他
        redirect_url = location.href;
      }

      // if (this.$kkmh.qs()["from"] == "baidu") {
      //   redirect_url =
      //     "https://smartprogram.baidu.com/developer/activity/unitedmember/index.html";
      // } else {
      //   redirect_url = location.href;
      // }

      log("支付成功后跳转url-----", redirect_url);

      this.res_payment = {
        action: "poppayment", //1.poppayment[弹出收银台] 2.pullupvip[拉起vip半屏] 3.pullupkkb[拉起kkb半屏-待实现]
        //接口所需字段
        third_activity: this.third_activity, //string 活动ID
        good_type: 2, //int 1.kkb 2.vip
        good_id: this.open_price.id, //int 76
        coupon_id:
          this.open_price.coupon.id != 0
            ? this.open_price.coupon.id.toString()
            : "", //string '5733161272790585360' 优惠券id
        coupon_type: 0, //int 0:使用第一个, 1:使用最大的优惠券 2:待扩充
        cps: this.$kkmh.qs()["cps"] ? this.$kkmh.qs()["cps"] : "", //string 下单接口时要传递的字段，用来服务端统计所用，看产品提供
        comic_id: this.comic_id, //int 漫画id
        topic_id: this.topic_id, //int 专题id
        source_type: 0, //int 1：签到，2：皇冠，3：作品，4：礼包
        invite_code: "", //string 拉新活动时候会有邀请码
        //埋点所需字段
        trigger_page: "联合会员买1赠N活动", //埋点属性TriggerPage
        origin: this.origin, //埋点属性EntranceName
        //回调地址
        redirect_url: redirect_url, //支付成功之后想跳回的h5地址
        //小程序
        bind_phone: bind_phone, // 默认：0 不绑定，1绑定。百度小程序支付前验证是否需要绑定手机号
      };
      log("设置端外支付payment", this.res_payment);

      this.fromBaiduCallPay();
    },
    // 直付组建返回
    res_pay(res) {
      let { code, data = {}, message = "" } = res;
      log("直付组件返回-----", res);
      switch (code) {
        case 1: //打开
          log("直付组件打开---");
          break;
        case 2: //关闭
          break;
        case 200: //支付成功回调
          log("直付组件支付成功---", res.data);
          break;
        case 401:
          // 在此判断未登录
          log("直付组件支付未登录---", res);
          this.login();
          break;
        case -1: //出错
          log("直付组件支付出错---", res);
      }
    },
    // 显示手机号收集弹窗
    showPhoneNumber() {
      let fixele = document.querySelector(".home");
      fix(fixele);

      this.SET_SHOW_PHONE_NUMBER(true);
      this.$doTrack({
        // platform-预约提醒 bottom-预约提醒吸底
        name: this.from == "platform" ? "预约提醒" : "预约提醒吸底",
      });
    },
    // 开通会员
    openMember() {
      if (!this.is_login && this.$kkmh.ua().kkmh) {
        // 端内未登录
        log("端内未登录");
        this.refreshH5Init("need");
        return;
      }

      // 超过最大开通时长
      if (this.member_remain_days >= 3) {
        log("最大购买时长", this.member_remain_days);
        this.$showToast("会员购买时长已达上限");
        return;
      }

      if (this.is_login && this.$kkmh.ua().kkmh) {
        // 端内已登录，拉起收银台支付
        this.appDirectPay();
      }

      if (!this.$kkmh.ua().kkmh) {
        // 端外,通过直付组件判断是否登录
        log("此时参数----", this.res_payment);
        this.outAppPay();
      }
    },

    // 端外支付
    outAppPay() {
      log("端外支付");

      this.SET_CALL_APPPAY(false);

      if (JSON.stringify(this.res_payment) === "{}") {
        this.setReqPayment();
        log("重新给res_payment设定值---", this.res_payment);
      }

      this.visible = true;
    },
    // 格式化客户端返回res
    formatRes(res) {
      if (!res.code) {
        return res.data;
      }
      return res;
    },
    // 端内唤起收银台直接支付
    appDirectPay() {
      log("唤起收银台third_activity", this.third_activity);
      this.SET_SHOW_LOADING(true);
      let pay_info = JSON.stringify({
        topic_id: this.topic_id,
        comic_id: this.comic_id,
        coupon_id:
          this.open_price.coupon.id != 0
            ? this.open_price.coupon.id.toString()
            : "",
        third_activity: this.third_activity,
      });
      log("唤起收银台pay_info", pay_info);
      h5directpay({
        data: {
          pay_info: pay_info,
          track_info: {
            TriggerPage: this.$kkmh.qs()["origin"]
              ? this.$kkmh.qs()["origin"]
              : "homepage",
            CurPage: "联合会员买1赠N活动",
          },
          good_id: this.open_price.id,
          good_type: 1, //0-kkb 1-vip
          pay_source: 2, //活动页
          from_page: "联合会员买1赠N活动",
        },
        callback: (res) => {
          log("调起收银台回调", res);
          if (res.data.pay_status == 4) {
            log("好友代付成功", res);
            // 1.5s后刷新数据，以防到账有延迟
            setTimeout(() => {
              this.SET_REFRESH_DATA(true);
              this.SET_SHOW_LOADING(false);
            }, 1500);
          }
          let { code, data = {}, message = "" } = this.formatRes(res);
          if (code !== 200) {
            this.$showToast("返回数据异常, 请稍候再试!");
            return false;
          }
          var resultMap = {
            1: "支付成功",
            2: "支付失败",
            3: "取消",
            4: "好友代付",
            5: "请稍后再试", //实际为：没有找到对应商品，此处只为hack客户端问题
            6: "好友代付回退",
            7: "选中支付方式", // 重新获取商品
          };

          if (data.pay_status == 1) {
            log("支付成功", data);
            this.$showToast("开通成功，请至页面内领取");
            // 1.5s后刷新数据，以防到账有延迟
            setTimeout(() => {
              this.SET_REFRESH_DATA(true);
              this.SET_SHOW_LOADING(false);
            }, 1500);

            this.$doTrack({
              name: this.from == "bottom" ? "限量抢购吸底" : "限量抢购",
              MembershipPrdName: this.open_price.title,
              CurrentPrice: this.open_price.price,
              IsOpenSuccess: 1,
            });
          }
          if (data.pay_status == 2 || data.pay_status == 3) {
            this.SET_SHOW_LOADING(false);
            log("支付失败||支付取消");
            this.$doTrack({
              name: this.from == "bottom" ? "限量抢购吸底" : "限量抢购",
              MembershipPrdName: this.open_price.title,
              CurrentPrice: this.open_price.price,
              IsOpenSuccess: 0,
            });
          }
          if (data.pay_status == 7 && data.pay_payment.type == 4) {
            this.SET_SHOW_LOADING(false);
            log("重新获取iap商品", data);
            this.SET_REFRESH_MEMBERGOOD_LIST(true);
            this.$showToast("支付环境已更新,请重新选择支付");
          }
        },
      });
    },
    // 登录
    login() {
      if (this.isMiniProgram()["wechatmini"]) {
        if (this.miniProgramNotLogin()) {
          log("微信小程序未登录");
          // wx.miniProgram.navigateTo({ url: "/pages/login/login" });
          // wx.navigateTo({ url: "/pages/login/login" });

          miniprogramNav("/pages/login/login");
        } else {
          log("微信小程序已登录");
          this.outAppPay();
        }
      } else if (this.isMiniProgram()["qqmini"]) {
        if (this.miniProgramNotLogin()) {
          log("qq小程序未登录");
          // qq.miniProgram.navigateTo({ url: "/pages/login/login" });
          // qq.navigateTo({ url: "/pages/login/login" });

          miniprogramNav("/pages/login/login");
        } else {
          log("qq小程序已登录");
          this.outAppPay();
        }
      } else if (this.isMiniProgram()["baidumini"]) {
        if (this.miniProgramNotLogin()) {
          log("百度小程序未登录");
          // swan.navigateTo({ url: "/pages/login/login" });

          miniprogramNav("/pages/login/login");
        } else {
          log("百度小程序已登录");
          this.outAppPay();
        }
      } else {
        // 端外浏览器中
        log("端外浏览器中未登录");
        // let webHost =
        //   "https://" +
        //   (/kuaikanmanhua/.test(location.host)
        //     ? "m.kuaikanmanhua.com"
        //     : "m.quickcan.cn");
        // location.href =
        //   webHost + "/mob/login?redirect=" + encodeURIComponent(location.href);

        this.loginWeb();
      }
    },
    // 端外浏览器中登录
    loginWeb() {
      let webHost =
        "https://" +
        (/kuaikanmanhua/.test(location.host)
          ? "m.kuaikanmanhua.com"
          : "m.quickcan.cn");
      location.href =
        webHost + "/mob/login?redirect=" + encodeURIComponent(location.href);
    },
    // 是否在小程序中
    isMiniProgram() {
      let is_mini = {
        wechatmini: window.__gvalkkmh.ua.wechatmini,
        qqmini: window.__gvalkkmh.ua.qqmini,
        baidumini: window.__gvalkkmh.ua.baidumini,
      };
      return is_mini;
    },
    // 小程序中未登录
    miniProgramNotLogin() {
      let str = decodeURIComponent(this.$kkmh.qs()["kkid"]);
      let uid = str.split("#")[1];
      return uid == "";
    },
    // 跳转领取页面
    jumpToGetPage() {
      let charge_activity_name = this.activity_name,
        activity_name = this.activity_name_topic,
        origin = this.origin,
        eruda = /kuaikanmanhua/.test(location.host)
          ? `eruda=${false}`
          : `eruda=${true}`;

      let topage = `${location.protocol}//${location.host}/act/link_vip_assign_list?conf2fullscreen=1&conf2scrollwhitearea=1&charge_activity_name=${charge_activity_name}&activity_name=${activity_name}&origin=${origin}&${eruda}&serviceType=pay`;

      if (this.$kkmh.ua().kkmh) {
        this.$kkmh.requestHybrid({
          tagname: "forward",
          param: {
            totype: "h5",
            topage: topage,
            todata: {},
          },
          callback(res) {
            cb && cb(res);
          },
        });
      } else if (
        this.isMiniProgram()["wechatmini"] ||
        this.isMiniProgram()["qqmini"] ||
        this.isMiniProgram()["baidumini"]
      ) {
        let miniPramUrl = `/pages/webview/webview?type=19&url=${encodeURIComponent(
          topage
        )}`;
        miniprogramNav(miniPramUrl);
        // location.href = topage;
      } else {
        location.href = topage;
      }

      this.$doTrack({ name: "领取权益" });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../css/common.scss";
.open_btn_container {
  .open_btn_double {
    @include boxsize(653, 100);
    @include layout(space-between, center);
    .open_btn_left {
      @include boxsize(240, 100);
      @include bgimg("../img/get-btn.png", 100%, 100%);
    }
    .open_btn_right {
      @include boxsize(395, 100);
      @include bgimg("../img/open-btn-right.png", 100%, 100%);
      position: relative;
      .open_price {
        @include layout(center, flex-end);
        position: absolute;
        left: trans(237);
        top: trans(10);
        .price_tag {
          @include fontstyle(#ff4031, 50);
          font-weight: bold;
        }
        .price_num {
          @include fontstyle(#ff4031, 60);
          line-height: trans(72);
          font-weight: bold;
        }
      }
      .save_container {
        @include layout(center, center);
        height: trans(36);
        padding: 0 trans(23);
        flex-wrap: nowrap;
        font-size: 0;
        background: #422222;
        border-radius: trans(18) trans(18) trans(18) trans(4);
        position: absolute;
        right: trans(8);
        top: trans(-22);
        .save_tag {
          @include fontstyle(#fff, 20);
          line-height: 1.15;
          font-weight: bold;
        }
        .save_num {
          @include fontstyle(#fee437, 22);
          line-height: 1.15;
          font-weight: bold;
          margin-left: trans(5);
        }
      }
    }
  }
  .open_btn_single {
    @include boxsize(625, 100);
    margin: 0 auto;
    .order_btn {
      @include boxsize(625, 100);
      @include bgimg("../img/order-btn.png", 100%, 100%);
      position: relative;
      animation: btnScale 1s ease-in-out both infinite;
      .open_price {
        @include layout(center, flex-end);
        position: absolute;
        left: trans(314);
        top: trans(10);
        .price_tag {
          @include fontstyle(#ff4031, 40);
          font-weight: bold;
        }
        .price_num {
          @include fontstyle(#ff4031, 68);
          line-height: trans(72);
          font-weight: bold;
        }
        .original_price {
          @include fontstyle(#422222, 26);
          @include layout(center, center);
          opacity: 0.4;
          position: absolute;
          left: trans(120);
          top: trans(30);
          text-decoration: line-through;
        }
      }
      .save_container {
        @include layout(center, center);
        height: trans(36);
        padding: 0 trans(23);
        flex-wrap: nowrap;
        font-size: 0;
        background: #422222;
        border-radius: trans(18) trans(18) trans(18) trans(4);
        position: absolute;
        right: trans(28);
        top: trans(-22);
        .save_tag {
          @include fontstyle(#fff, 20);
          line-height: 1.15;
          font-weight: bold;
        }
        .save_num {
          @include fontstyle(#fee437, 22);
          line-height: 1.15;
          font-weight: bold;
          margin-left: trans(5);
        }
      }
    }
  }
  .has_ordered_btn {
    @include boxsize(625, 100);
    @include bgimg("../img/order-btn-grey.png", 100%, 100%);
    margin: 0 auto;
  }
  .single_open_btn {
    @include boxsize(625, 100);
    @include bgimg("../img/single-open-btn.png", 100%, 100%);
    position: relative;
    animation: btnScale 1s ease-in-out both infinite;
    .open_price {
      @include layout(center, flex-end);
      position: absolute;
      left: trans(314);
      top: trans(10);
      .price_tag {
        @include fontstyle(#ff4031, 40);
        font-weight: bold;
      }
      .price_num {
        @include fontstyle(#ff4031, 68);
        line-height: trans(72);
        font-weight: bold;
      }
      .original_price {
        @include fontstyle(#422222, 26);
        @include layout(center, center);
        opacity: 0.4;
        position: absolute;
        left: trans(120);
        top: trans(30);
        text-decoration: line-through;
      }
    }
    .save_container {
      @include layout(center, center);
      height: trans(36);
      padding: 0 trans(23);
      flex-wrap: nowrap;
      font-size: 0;
      background: #422222;
      border-radius: trans(18) trans(18) trans(18) trans(4);
      position: absolute;
      right: trans(28);
      top: trans(-22);
      .save_tag {
        @include fontstyle(#fff, 20);
        line-height: 1.15;
        font-weight: bold;
      }
      .save_num {
        @include fontstyle(#fee437, 22);
        line-height: 1.15;
        font-weight: bold;
        margin-left: trans(5);
      }
    }
  }
  @keyframes btnScale {
    0%,
    100% {
      transform: scale(1.05);
    }
    50% {
      transform: scale(1);
    }
  }
  .get_member_auth {
    @include boxsize(625, 100);
    @include bgimg("../img/get-member-auth-btn.png", 100%, 100%);
  }
  .no_open_chance {
    @include boxsize(625, 100);
    @include bgimg("../img/no-open-chance.png", 100%, 100%);
  }
  .user_cant_open {
    @include boxsize(625, 100);
    @include bgimg("../img/user-cant-open.png", 100%, 100%);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/OpenBtn.vue